import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Chip from '~components/chip';
import { BOOKING_STATUS } from '~graphql-types';

const useStyles = makeStyles({ root: { cursor: 'inherit' } });

const BookingStatusChip = React.forwardRef((props, ref) => {
  const { t } = useTranslation('graphql');
  const { status, className, ...otherProps } = props;

  const classes = useStyles();

  const getChipProps = useMemo(() => {
    switch (status) {
      case BOOKING_STATUS.ENQUIRY:
      case BOOKING_STATUS.APPLIED:
      case BOOKING_STATUS.ROOM_SELECTED:
      case BOOKING_STATUS.SELECTION_COMPLETED:
      case BOOKING_STATUS.DETAILS_COMPLETED:
      case BOOKING_STATUS.TERMS_ACCEPTED: {
        return { themeColor: 'orangeBg', labelColor: 'orangeDark' };
      }
      case BOOKING_STATUS.BOOKING_CONFIRMED: {
        return { themeColor: 'greenBg', labelColor: 'greenDark' };
      }
      case BOOKING_STATUS.BOOKING_COMPLETED: {
        return { themeColor: 'blueBg', labelColor: 'blueDark' };
      }
      case BOOKING_STATUS.RESIDENT: {
        return { themeColor: 'violetBg', labelColor: 'violetDark' };
      }
      case BOOKING_STATUS.CANCELLED: {
        return { themeColor: 'redBg', labelColor: 'redDark' };
      }
      case BOOKING_STATUS.EXPIRED:
      case BOOKING_STATUS.PAST:
        return { themeColor: 'greyE8', labelColor: 'grey66' };
      default: {
        return null;
      }
    }
  }, [status]);

  return (
    <Chip
      label={t(`booking_status.${status}`)}
      {...getChipProps}
      {...otherProps}
      className={classNames(classes.root, className)}
      ref={ref}
    />
  );
});

BookingStatusChip.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string.isRequired,
};
BookingStatusChip.defaultProps = {
  className: undefined,
};

export default BookingStatusChip;
